import React from "react";
import { useLanguage } from "@/lib/i18n";

export default function InsightSection() {
  const { t } = useLanguage();
  const stats = t("insight.stats") || [];

  return (
    <section
      className="relative bg-[#0B2545] text-[#F9F8F6] py-24 sm:py-32 lg:py-44 grain-overlay"
      data-testid="insight-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-3 reveal">
            <p className="text-xs uppercase tracking-[0.24em] text-[#B4C5A4] font-sans-display">
              {t("insight.eyebrow")}
            </p>
            <div className="mt-6 h-px w-16 bg-[#B4C5A4]" />
          </div>

          <div className="lg:col-span-9 reveal">
            <p
              className="font-serif-display text-3xl sm:text-5xl lg:text-[60px] leading-[1.1] tracking-tight"
              data-testid="insight-statement"
            >
              {t("insight.line1")}
              <br />
              <span className="italic font-light">
                {t("insight.line2a")}{" "}
                <span className="text-[#B4C5A4]">{t("insight.capacity")}</span>{" "}
                <span className="text-[#B4C5A4]">{t("insight.autonomy")}</span>{" "}
                <span className="text-[#B4C5A4]">{t("insight.confidence")}</span>
                {t("insight.line2b")}
              </span>
            </p>

            <div className="mt-16 grid sm:grid-cols-3 gap-10 max-w-3xl">
              {stats.map((label, i) => (
                <div key={i}>
                  <p className="font-sans-display text-3xl sm:text-4xl text-[#F9F8F6] tracking-tight tabular-nums">
                    0{i + 1}
                  </p>
                  <p className="mt-3 text-sm text-[#F9F8F6]/70 leading-relaxed">{label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
